import { ObjectType, AspObject } from './AspObject';
import { TrackCoreObject } from './TrackCoreObject';
import { ObjectsPool } from './ObjectsPool';
import * as enums from '../common/enums';
import * as utils from '../common/utils';
import { ITracksPool, IMapMngr } from './interfaces';
import { IUserActionResponder } from '../user-action/user-action.service';
import * as consts from '../common/consts';
import { AppConfig } from '../app.config';
import { AroService } from '../aro/aro.service';
import { ThreatPolygonHandler } from 'src/app/asp/ThreatPolygon';
import { ImpactPointHandler } from 'src/app/asp/ImpactPoint';
import { TrackObject } from './../../../app/asp/TrackObject';

export const trackSymbols = initTrackSymbols();

function initTrackSymbols() {
  let symbols = new Map<number, string>();

  // Loading all the necessary images
  symbols.set(enums.Hostility.Pending, enums.HostilityTitle(enums.Hostility.Pending));
  symbols.set(enums.Hostility.Unkn, enums.HostilityTitle(enums.Hostility.Unkn));
  symbols.set(enums.Hostility.AssumedFriend, enums.HostilityTitle(enums.Hostility.AssumedFriend));
  symbols.set(enums.Hostility.Friend, enums.HostilityTitle(enums.Hostility.Friend));
  symbols.set(enums.Hostility.Neutral, enums.HostilityTitle(enums.Hostility.Neutral));
  symbols.set(enums.Hostility.Suspect, enums.HostilityTitle(enums.Hostility.Suspect));
  symbols.set(enums.Hostility.Hostile, enums.HostilityTitle(enums.Hostility.Hostile));
  symbols.set(7, "missile-weapon");
  symbols.set(8, "fighter-plane");

  return symbols;
}

export class TracksCorePool extends ObjectsPool implements ITracksPool, IUserActionResponder {
  userAction: number;
  userActionObj: AspObject;

  constructor() {
    super(ObjectType.Track, consts.MSG_TYPE_TRACK, undefined, true /* hookable */, false /* clickable */, true /* support picking */);
  }

  handleMsg(msgObj: any): boolean {
    if (AppConfig.settings.ShowLogs)
      console.log("track -" + msgObj.TrackId + " msg:", msgObj);

    let track: TrackCoreObject = null;
    let id: any = msgObj.TrackId;
    if (id == -1)
      id = msgObj.TrackUUID;
    let trackId = AspObject.generateId(this.objectType, id, null);
    let newTrack = !this.allObjects.has(trackId);

    // if delete track
    if (msgObj.TrackStat == enums.TrackStatus.Delete) {
      if (!newTrack) {
        this.deleteObject(this.allObjects.get(trackId));
        if (AppConfig.settings.ShowLogs)
          console.log("Deleted", trackId);
      }
      return false;
    }

    if (newTrack) {
      track = this.createTrack(msgObj);
      if (msgObj.TrackStat == enums.TrackStatus.Lost) // lost
        return false;
      this.addObject(track);
      if (AppConfig.settings.ShowLogs)
        console.debug("Added", trackId);
    }
    else
      track = this.allObjects.get(trackId) as TrackCoreObject;

    track.handleMsg(msgObj);
    this.setTrackSymbol(track);

    if (msgObj.Polygon != undefined) {
      if (track.trackType == enums.TrackType.ABT)
        ThreatPolygonHandler.getSelf().handleMsg(msgObj.Polygon);
      if (track.trackType == enums.TrackType.TBM)
        ImpactPointHandler.getSelf().handleMsg(msgObj.Polygon);
    }
  }

  // private isDeleteMsg(msgObj): boolean {
  //   return msgObj.DeleteTrack;
  // }

  protected createTrack(msgObj): TrackCoreObject {
    let id: any = msgObj.TrackId;
    if (!msgObj.TrackId)
      id = msgObj.TrackUUID;
    return new TrackCoreObject(this, this.objectType, id);
  }

  private setTrackSymbol(track: TrackCoreObject) {
    // if (track.trackType == enums.TrackType.TBM) {
    //   track.symbol = "missile-weapon";
    //   track.svgSymbol = utils.getPlaneSymbol(track.symbol);
    //   return;
    // }

    // let symbol = trackSymbols.has(track.hostility) ? trackSymbols.get(track.hostility) : trackSymbols.get(enums.Hostility.Unkn);
    // if (!trackSymbols.has(track.hostility))
    //   console.log("Missing symbol for air pltf", enums.AirPltf[track.trackPltf]);

    // track.symbol = symbol;
    // track.svgSymbol = utils.getPlaneSymbol(symbol);

    track.symbol = "fighter-plane";
    track.hostility = enums.Hostility.Unkn;
    track.svgSymbol = utils.getPlaneSymbol(track.symbol);

  }

  // Support textual search by operator
  supportSearch(): boolean {
    return true;
  }

  // defined in IObjectsPool
  contextMenuActions(obj: AspObject): number[] {
    let actions = [consts.USER_ACTION_ARO, consts.USER_ACTION_DYNAMIC_CENTER, consts.USER_ACTION_HISTORY, consts.USER_ACTION_SIDE_VIEW];
    // we gonna check if the track has the special polygon if so we gonna add an entry here..
    if ((obj as TrackObject).HideSendToSmart != undefined && !(obj as TrackObject).HideSendToSmart)
      actions.push(consts.USER_ACTION_FORCE_SEND_POLY);
    return actions;
  }

  canBePicked(action: number, actionObj: AspObject, nextObj: AspObject): boolean {
    if (actionObj == nextObj)
      return false;
    if (action == consts.USER_ACTION_RULER) {
      return true;
    }
    return false;
  }

  handleUserAction(action: number, obj: AspObject, mapMngr: IMapMngr): boolean {
    if (action == consts.USER_ACTION_HISTORY || action == consts.USER_ACTION_DYNAMIC_CENTER || action == consts.USER_ACTION_SIDE_VIEW || action == consts.USER_ACTION_FORCE_SEND_POLY) {
      return mapMngr.handleUserAction(action, obj);
    }
    return super.handleUserAction(action, obj, mapMngr);
  }

  // Handle user action respone
  response(action: number, status: boolean, objects?: AspObject[], data?: any): void {
    this.userAction = undefined;
    this.userActionObj = undefined;
  }

}
